import { render, staticRenderFns } from "./DataTableCard.vue?vue&type=template&id=237ba434&scoped=true&"
import script from "./DataTableCard.vue?vue&type=script&lang=js&"
export * from "./DataTableCard.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataTableCard.vue?vue&type=style&index=1&id=237ba434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ba434",
  null
  
)

export default component.exports